import React from "react";

import AutocompleteSelectInput from "veneer/AutocompleteSelectInput";
import Grid from "veneer/Grid";

import { Filter, Media } from "../model";

interface MediaTableFiltersProps {
  onChange: (newValue: Filter) => void;
  typeOptions: ReadonlyArray<Media["friendlyType"]>;
  value: Filter;
}

export default function MediaTableFilters({
  onChange,
  typeOptions,
  value,
}: MediaTableFiltersProps) {
  return (
    <div data-table-filters="true">
      <Grid columns={{ xs: 2, xl: 4 }} container spacing={1}>
        <Grid item xs={1}>
          <AutocompleteSelectInput
            inputProps={{ label: "Type" }}
            onChange={(_e, opt: Media["friendlyType"] | null) =>
              onChange({ ...value, type: opt ?? null })
            }
            options={typeOptions}
            size="small"
            value={value.type || null}
          />
        </Grid>
      </Grid>
    </div>
  );
}
